import { useTranslation } from 'react-i18next';
import { addMonths, format, isThisMonth, startOfMonth, subMonths } from 'date-fns';

import { FlexBox } from '@sternum/styled-system';
import { IconButton } from '@sternum/ui';
import { Icon } from '@sternum/web/components/Icon';
import { Text } from '@sternum/web/components/Text';
import { namespaces } from '@sternum/web/services/i18n';

import { OptionsBox, TodayButton, Wrapper } from './MonthNavigator.styles';

interface MonthNavigatorProps {
  shownDate: Date;
  changeShownDate: (newDate: Date) => void;
}

export function MonthNavigator({ shownDate, changeShownDate }: MonthNavigatorProps) {
  const isShownCurrentMonth = isThisMonth(shownDate);
  const { t } = useTranslation(namespaces.common);

  return (
    <Wrapper>
      <Text size={12} weight={600}>
        {format(shownDate, 'MMMM yyyy')}
      </Text>

      <OptionsBox>
        <TodayButton
          data-hidden={isShownCurrentMonth}
          variant="tertiary"
          onClick={() => {
            changeShownDate(startOfMonth(new Date()));
          }}
        >
          {t('today')}
        </TodayButton>

        <FlexBox>
          <IconButton
            onClick={() => {
              changeShownDate(subMonths(shownDate, 1));
            }}
            size="medium"
            variant="tertiary-third"
            aria-label="prev-month-button"
          >
            <Icon type="ChevronLeftIcon" />
          </IconButton>

          <IconButton
            onClick={() => {
              changeShownDate(addMonths(shownDate, 1));
            }}
            size="medium"
            variant="tertiary-third"
            aria-label="next-month-button"
          >
            <Icon type="ChevronRightIcon" />
          </IconButton>
        </FlexBox>
      </OptionsBox>
    </Wrapper>
  );
}
